/**
 * For any list of `.inlineList--pipe > .inlineList__item`, if an item is teh last one on the line, it will remove the `|` separator
 */
export default function () {
  const items = document.querySelectorAll(".inlineList--pipe .inlineList__item");
  let previousY;
  items.forEach((item, index) => {
    const bbox = item.getBoundingClientRect();

    if (bbox.y !== previousY) {
      const previous = items[index - 1];
      if (previous) {
        previous.style.setProperty("--inlineListSep", "''");
      }
    }

    previousY = bbox.y;
  })
}